import { get } from 'lodash'

const loginState = 'login'

uiRouterAuthenticationRun.$inject = ['userProfile', '$state', '$transitions']
function uiRouterAuthenticationRun(userProfile, $state, $transitions) {

  $transitions.onStart({}, transition => {
    const targetState = transition.targetState()
    const definition = targetState.state()

    const authenticatedOnly = get(definition, 'data.authenticatedOnly')
    if (authenticatedOnly && !userProfile.isAuthenticated()) {
      return $state.target(loginState, {
        returnState: {
          name: targetState.name(),
          params: targetState.params()
        }
      })
    }

  })
}

export default uiRouterAuthenticationRun